<!-- -------------------------------------------------------------- -->
<!-- Added Successfully  -->
<!-- -------------------------------------------------------------- -->

<mat-dialog-content>
  <h4 class="f-s-18 f-w-500">Employee Successfully Added.</h4>
  <span>You can find your employee at last of table.</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Ok</button>
</mat-dialog-actions>
